import { Check, Quote } from "lucide-react";
import { FOUNDER } from "@/data/site";
import { Eyebrow } from "@/components/Shared";

export const MeetFounder = () => {
  return (
    <section data-testid="meet-founder" className="section-py">
      <div className="container-px mx-auto max-w-[1400px] grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="img-zoom-wrap relative overflow-hidden rounded-[2rem] aspect-[4/5] max-w-md">
            <img src={FOUNDER.image} alt={`${FOUNDER.name}, ${FOUNDER.role}`} className="img-zoom h-full w-full object-cover object-top" />
          </div>
          <div className="absolute -bottom-6 right-0 lg:-right-6 hidden sm:block rounded-3xl bg-brand-greenDark text-white p-6 w-60">
            <Quote size={24} className="text-white/40" />
            <p className="mt-2 text-sm leading-relaxed font-light">
              "Healthy, authentic food should be something every family is proud to share."
            </p>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <Eyebrow>Our Story</Eyebrow>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight text-brand-ink">
            Meet {FOUNDER.name}
          </h2>
          <p className="mt-2 text-brand-purple font-medium">{FOUNDER.role}</p>
          <div className="mt-6 space-y-4">
            {FOUNDER.bio.map((p, i) => (
              <p key={i} className="text-brand-slate leading-relaxed text-base md:text-lg">{p}</p>
            ))}
          </div>
          <ul className="mt-7 space-y-3">
            {FOUNDER.highlights.map((h) => (
              <li key={h} className="flex items-center gap-3 text-brand-ink">
                <span className="grid h-6 w-6 place-items-center rounded-full bg-brand-mist text-brand-greenDark shrink-0"><Check size={13} /></span>
                {h}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
